import { render, staticRenderFns } from "./Global.vue?vue&type=template&id=48c0cd83&"
import script from "./Global.ts?vue&type=script&lang=ts&"
export * from "./Global.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports